// ***************
// src/services/a_userUtils.js
// objetivo: encriptar e decriptar tokens
// autor: WdePaula / MVinfo 
// data/hora: 16/12/24 | 12h59 - cópia (semelhante à do agendex cliente web) exclusiva para uso somente no admin
// ***************




import { decrypt } from './cryptoUtils';

export const a_getUserData = () => {
    const encryptedTokenLG = localStorage.getItem('tokenlg');
    const encryptedTokenAAW = localStorage.getItem('tokenaaw');

    if (encryptedTokenLG && encryptedTokenAAW ) {
        try {
            const decryptedTokenLG = decrypt(encryptedTokenLG);
            const decryptedTokenAAW = decrypt(encryptedTokenAAW);

            if (decryptedTokenLG === "true") {
                // Assumindo que decryptedTokenAcw já é um objeto JavaScript
                const userObject = decryptedTokenAAW;
                // console.log('dentro do decrypt p_userUtils: ', userObject);
                return {
                    // indEmpresa: userObject.indempresa || 0,
                    // bloqueio: userObject.lock || 0, // acrescentado 4/10/24w (0=cpfcnpj não verificado / 1=verificado)
                    // tipoAtendimento: userObject.tipoAtendimento || 0, // 0=não tem funcionário / 1=tem funcionários
                    // tipoAgenda: userObject.tipoAgenda || 0, // 0=global / 1=individual // 15/10/24w
                    // agenda_fechada: userObject.agenda_fechada || 0, // 0=aberta / 1=fechada // 15/10/24w
                    // cidade: userObject.cidade || '',
                    // dias_FimContrato: userObject.diasFimContrato || 0 // mínimo de 0 dia para encerrar contrato 7/12/24w
                    userId: userObject.id_usuario || 0,
                    emailValidado: userObject.ativa_conta || 0,
                    validado: userObject.validado || 0, // acrescentado 4/10/24w (0=cpfcnpj não verificado / 1=verificado)
                    TAMANHO_PAGINA: userObject.TAMANHO_PAGINA || 10 // acrescentado tamanho página
                };
                 
            } else {
                // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
                // return { userId: 0, emailValidado: 0, indEmpresa: 0, validado: 0, bloqueio: 1, tipoAtendimento: 0, tipoAgenda: 0, agenda_fechada: 0, cidade: '', TAMANHO_PAGINA: 10, dias_FimContrato: 0 };
                return { userId: 0, emailValidado: 0, validado: 0, TAMANHO_PAGINA: 10 };

            }
        } catch (error) {
            console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
            // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
            // return { userId: 0, emailValidado: 0, indEmpresa: 0, validado: 0, bloqueio: 1, tipoAtendimento: 0, tipoAgenda: 0, agenda_fechada: 0, cidade: '', TAMANHO_PAGINA: 10, dias_FimContrato: 0 };
            return { userId: 0, emailValidado: 0, validado: 0, TAMANHO_PAGINA: 10 };
        }
    }

    // return { userId: 0, emailValidado: 0, indEmpresa: 0, tipoAtendimento: 0, cidade: ''};
    // return { userId: 0, emailValidado: 0, indEmpresa: 0, validado: 0, bloqueio: 1, tipoAtendimento: 0, tipoAgenda: 0, agenda_fechada: 0, cidade: '', TAMANHO_PAGINA: 10, dias_FimContrato: 0 };
    return { userId: 0, emailValidado: 0, validado: 0, TAMANHO_PAGINA: 10 };
};